<template>
    <div class="vx-col w-full mb-base">
        <vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back()"></vs-button>
                    <h4 class="ml-5">Item Check</h4>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="ID" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="RDO Reference" v-model="data.reference"  :disabled="true" />
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="RDO Status" v-model="data.status" disabled />
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-10">
                <vs-tab label="Outstanding">
                    <vs-button class="btn mb-5 mr-1 mt-3" @click="storeAll">Save</vs-button>
                    <vs-button class="btn mb-5" @click="fetchData">Refresh</vs-button>
                    <div style="overflow-y: auto;">
                        <vs-table stripe :data="data.outstanding_items" v-model="outstandingSelected" multiple>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Product</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th>Qty</vs-th>
                                <vs-th>UoM</vs-th>
                                <vs-th>Stock Type</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Outstanding Qty</vs-th>
                                <vs-th>Base UoM</vs-th>
                                <vs-th>Actions</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr" :v-show="tr.status !== 'delete'">
                                    <vs-td>
                                        {{ indextr + 1 }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.product.product_code }}
                                    </vs-td>


                                    <vs-td>
                                        {{ tr.product.description_1 }}
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.pack_id"/>
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.batch"/>
                                    </vs-td>

                                    <vs-td>
                                        <flat-pickr class="w-full" v-model="tr.expired_date"/>
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.qty" @input="convertQty(tr)"/>
                                    </vs-td>

                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.uom_id"
                                            width="100%"
                                            autocomplete
                                            @change="uomChange(tr)"
                                        >
                                            <vs-select-item v-for="(item, index) in tr.uom_options" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </vs-td>

                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.stock_type_id"
                                            width="100%"
                                            autocomplete
                                        >
                                            <vs-select-item v-for="(item, index) in stockTypeOption" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.base_qty }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.outstanding_qty }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.product.base_uom.uom.name }}
                                    </vs-td>
                                    <vs-td>
                                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="viewProduct(tr, indextr)">Split</vs-button>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-tab>
                <vs-tab label="Checked Items">
                    <vs-button class="btn mb-5 mr-1 mt-3" @click="cancelCheck">Cancel Check</vs-button>
                    <vs-button class="btn mb-5" @click="fetchData">Refresh</vs-button>
                    <vs-table stripe multiple :data="data.checked_items" v-model="checkedSelected">
                        <template slot="thead">
                            <vs-th>Product</vs-th>
                            <vs-th>Description</vs-th>
                            <vs-th>Pack ID</vs-th>
                            <vs-th>Batch</vs-th>
                            <vs-th>Exp. Date</vs-th>
                            <vs-th>Qty</vs-th>
                            <vs-th>UoM</vs-th>
                            <vs-th>Stock Type</vs-th>
                            <vs-th>Base Qty</vs-th>
                            <vs-th>Base UoM</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
                                <vs-td>
                                    {{ tr.product_code }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.description }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.pack_id }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.batch }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.expired_date }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.check_qty }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.uom_name }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.stock_type_name }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.check_base_qty }}
                                </vs-td>

                                <vs-td>
                                    {{ tr.base_uom_name }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import { AgGridVue } from "ag-grid-vue"
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	import '@/assets/scss/vuesax/_wmsTheme.scss';

	export default {
		components:{
			vSelect,
			flatPickr,
			AgGridVue,
		},
		data() {
			return {
                data: {
                    id: '',
                    reference: '',
                    status: '',
                    outstanding_items: [],
                    checked_items: []
                },
                checkedSelected: [],
                outstandingSelected: [],
                stockTypeOption: [],
                isLoading: false
			}
		},
	watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
	},
	methods: {
		back() {
            this.$router.push({
                name: 'return-delivery-order-view',
                params: {
                    id: this.$route.params.id
                }
            })
        },
        storeAll() {
            let error = false
            const data = []
            this.outstandingSelected.map((item, index) => {
                data.push({
                    id: item.id,
                    qty: item.qty,
                    pack_id: item.pack_id,
                    batch: item.batch,
                    expired_date: item.expired_date,
                    uom_id: item.uom_id,
                    stock_type_id: item.stock_type_id,
                })

                if(item.base_qty > item.outstanding_qty) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon: 'icon-x',
                        text: `Line ${ index + 1 } - Base qty is higher than outstanding qty.`
                    })
                    error = true
                }
            })

            if(data.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon: 'icon-x',
                    text: `No data selected.`
                })
                error = true
            }

            if(error) {
                return false
            }
            else {
                this.isLoading = true
                this.$http.post('outbound/returndeliveryorder/storecheck', { data: data })
                .then(res => {
                    const message = res.data.message ? res.data.message : 'Check success.'
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        text: message
                    })

                    res.data.outstanding_items.map(item => {
                        const uoms = item.product.uoms.map(uom => {
                            return {
                                value: uom.uom_id,
                                label: uom.uom.name,
                                numerator: uom.numerator,
                                denominator: uom.denominator,
                            }
                        })

                        item.uom_options = uoms

                        item.qty = item.outstanding_qty
                        item.uom_id = item.base_uom_id
                        item.base_qty = item.outstanding_qty
                        item.numerator = 0
                        item.denominator = 0
                    })

                    this.data = res.data
                    this.data.outstanding_items.map(item => {
                        this.uomChange(item)
                    })

                    this.outstandingSelected = []
                    this.checkedSelected = []
                    this.isLoading = false
                })
                .catch(error => this.handleError(error))
            }
        },
        fetchData() {
            this.isLoading = true
            this.outstandingSelected = []
            this.checkedSelected = []
            this.$http.post('outbound/returndeliveryorder/checklist', { id: this.$route.params.id })
            .then(res => {
                res.data.outstanding_items.map(item => {
                    const uoms = item.product.uoms.map(uom => {
                        return {
                            value: uom.uom_id,
                            label: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                        }
                    })

                    item.uom_options = uoms

                    item.qty = item.outstanding_qty
                    item.uom_id = item.base_uom_id
                    item.base_qty = item.outstanding_qty
                    item.numerator = 0
                    item.denominator = 0
                })

                this.data = res.data
                this.data.outstanding_items.map(item => {
                    this.uomChange(item)
                })
                this.outstandingSelected = this.data.outstanding_items
                this.isLoading = false
            })
        },
        convertQty(detail) {
            detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
        },
        uomChange(detail) {
            const data = detail.uom_options[detail.uom_options.findIndex(a => a.value === detail.uom_id)]
            detail.numerator = data.numerator
            detail.denominator = data.denominator

            this.convertQty(detail)
        },
        fetchStockType() {
            this.isLoading = true
            return this.$http.post('master/stocktypes')
            .then(res => {
                this.stockTypeOption = res.data.data
            })
        },
        cancelCheck() {
            const id = this.checkedSelected.map(item => item.id)

            if(id.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon: 'icon-x',
                    text: `No data selected.`
                })

                return false
            }

            this.$http.post('outbound/returndeliveryorder/cancelcheck', { rdo_id: this.data.id, id: id })
            .then(res => {
                const message = res.data.message ? res.data.message : 'Cancel check success.'
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    text: message
                })

                res.data.outstanding_items.map(item => {
                    const uoms = item.product.uoms.map(uom => {
                        return {
                            value: uom.uom_id,
                            label: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                        }
                    })

                    item.uom_options = uoms

                    item.qty = item.outstanding_qty
                    item.uom_id = item.base_uom_id
                    item.base_qty = item.outstanding_qty
                    item.numerator = 0
                    item.denominator = 0
                })

                this.data = res.data
                this.data.outstanding_items.map(item => {
                    this.uomChange(item)
                })

                this.outstandingSelected = []
                this.checkedSelected = []
                this.isLoading = false
            })
            .catch(error => this.handleError(error))
        }
	},
    mounted() {
        this.fetchStockType().then(() => this.fetchData())
        .catch(error => {
            this.isLoading = false
        })
    }
}
</script>